import React, { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { Mail, Phone, User, MessageSquare } from "lucide-react";
import { fmtINR } from "@/lib/pricing";

export default function AdminEnquiries() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/enquiries").then((r) => setRows(r.data)).catch((err) => { console.error("[AdminEnquiries] load failed:", err); }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-10 space-y-6">
      <div>
        <div className="ornament mb-2">Customer Enquiries</div>
        <h1 className="font-display text-4xl text-ivory" style={{ fontWeight: 300 }}>Wishlist Submissions</h1>
        <p className="text-ivory/60 mt-1 text-sm">{rows.length} enquiries · WhatsApp-compiled requests</p>
      </div>

      {loading ? (
        <div className="space-y-3">{Array.from({ length: 4 }).map((_, i) => <div key={`enq-skel-${i}`} className="h-20 shimmer" />)}</div>
      ) : rows.length === 0 ? (
        <div className="text-center py-20 text-ivory/50">
          <MessageSquare className="w-10 h-10 mx-auto mb-4 text-rose-gold/30" />
          No enquiries yet. They'll appear here as customers send their wishlists.
        </div>
      ) : (
        <div className="space-y-4">
          {rows.map((r) => (
            <div key={r.id} className="glass p-6" data-testid={`enquiry-${r.id}`}>
              <div className="flex flex-wrap justify-between gap-4">
                <div>
                  <div className="flex items-center gap-2 text-ivory">
                    <User className="w-4 h-4 text-rose-gold" />
                    <span className="font-display text-lg">{r.customer_name}</span>
                  </div>
                  <div className="flex items-center gap-4 mt-1 text-sm text-ivory/60">
                    <span className="flex items-center gap-1"><Phone className="w-3 h-3" /> {r.customer_phone}</span>
                    <a href={`https://wa.me/${r.customer_phone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="text-rose-gold hover:underline">WhatsApp</a>
                  </div>
                </div>
                <div className="text-right">
                  <div className="overline text-ivory/50">Estimated</div>
                  <div className="font-display text-2xl text-champagne">{fmtINR(r.total_estimated)}</div>
                  <div className="text-[10px] text-ivory/40">{r.gst_included ? "incl. GST" : "excl. GST"}</div>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-white/5">
                <ul className="text-sm text-ivory/70 space-y-1">
                  {r.items.map((it, i) => (
                    <li key={`${r.id}-${it.tag_no || i}`} className="flex justify-between">
                      <span><span className="text-rose-gold mr-2">{it.tag_no}</span>{it.item_name}</span>
                      <span className="text-ivory">{fmtINR(it.price)}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-3 text-[11px] text-ivory/40">{new Date(r.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
